import { isErrorLogScreenshot } from 'utils/error-log/is-error-log-screenshot';
import { openScreenshotInNewTab } from 'utils/error-log/open-screenshot-in-new-tab';

type ErrorLogScreenshotViewProps = {
  screenshot: string | null;
};

export default function ErrorLogScreenshotView({
  screenshot
}: ErrorLogScreenshotViewProps) {
  if (!isErrorLogScreenshot(screenshot)) {
    return (
      <div className='flex h-full items-center justify-center rounded-md bg-gray-50 px-4 py-8 text-sm text-gray-400'>
        No screenshot was captured for this error.
      </div>
    );
  }

  return (
    <div className='flex h-full flex-col gap-2'>
      <button
        type='button'
        onClick={() => openScreenshotInNewTab(screenshot)}
        className='flex h-full items-center justify-center rounded-md border border-gray-200 bg-white'
      >
        <img
          src={screenshot}
          alt='Screen at the time of the error'
          className='max-h-64 w-full object-contain'
        />
      </button>
      <div className='text-center text-xs text-gray-500'>
        Click to view full size
      </div>
    </div>
  );
}
